/* eslint-disable no-unused-vars */
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Cell,
  ResponsiveContainer,
} from "recharts";

export default function CategoryChart() {
  // Medical categories data with your score and average score
  const medicalData = [
    {
      name: "Administration and health informatics",
      yourScore: 68,
      avgScore: 75,
      Type: 0,
    },
    { name: "Dermatology", yourScore: 82, avgScore: 76, Type: 0 },
    { name: "Ear, nose and throat", yourScore: 65, avgScore: 71, Type: 0 },
    {
      name: "Evidence based clinical practice",
      yourScore: 73,
      avgScore: 70,
      Type: 0,
    },
    { name: "Medicine", yourScore: 58, avgScore: 72, Type: 0 },
    { name: "Ophthalmology", yourScore: 77, avgScore: 70, Type: 0 },
    { name: "Paediatrics", yourScore: 45, avgScore: 74, Type: 0 },
    { name: "Psychiatry", yourScore: 85, avgScore: 76, Type: 0 },
    {
      name: "Surgical and musculoskeletal problems",
      yourScore: 61,
      avgScore: 69,
      Type: 0,
    },
    { name: "Women's health", yourScore: 79, avgScore: 73, Type: 0 },
  ];

  // Sort data by your score (descending)
  medicalData.sort((a, b) => b.yourScore - a.yourScore);

  // Energy production data
  const energyProdData = [
    { name: "Géothermie", yourScore: 10, avgScore: 8, typeEnergie: 0 },
    { name: "Solaire thermique", yourScore: 10, avgScore: 7, typeEnergie: 0 },
    {
      name: "Photovoltaïque toiture",
      yourScore: 10,
      avgScore: 9,
      typeEnergie: 0,
    },
    { name: "Ferme solaire", yourScore: 10, avgScore: 8, typeEnergie: 0 },
    { name: "Biomasse solaire", yourScore: 10, avgScore: 6, typeEnergie: 0 },
    { name: "Eolien terrestre", yourScore: 10, avgScore: 7, typeEnergie: 0 },
  ];

  // Sort energy production data
  energyProdData.sort((a, b) => b.yourScore - a.yourScore);

  // Colors for different categories
  const yourScoreColor = "#007bff";
  const avgScoreColor = "#6c757d";

  return (
    <div className="chart-container">
      <h2>Medical Categories Performance</h2>
      <ResponsiveContainer width="100%" height={550}>
        <BarChart
          data={medicalData}
          layout="vertical"
          margin={{
            top: 5,
            right: 30,
            left: 180,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" unit="%" domain={[0, 100]} />
          <YAxis type="category" dataKey="name" />
          <Tooltip formatter={(value) => `${value}%`} />
          <Legend />
          <Bar name="Your Score" dataKey="yourScore" fill={yourScoreColor} />
          <Bar name="Average Score" dataKey="avgScore" fill={avgScoreColor} />
        </BarChart>
      </ResponsiveContainer>

      <h2>Energy Production Performance</h2>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={energyProdData}
          layout="vertical"
          margin={{
            top: 5,
            right: 30,
            left: 180,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" unit="kWh" />
          <YAxis type="category" dataKey="name" />
          <Tooltip />
          <Legend />
          <Bar name="Your Score" dataKey="yourScore" fill={yourScoreColor} />
          <Bar name="Average Score" dataKey="avgScore" fill={avgScoreColor} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
